// removed by extract-text-webpack-plugin
module.exports = {"decorate":"_2OLA","topBorder":"DOXx","mr":"_1xND","ml":"_1cYd","view":"nVeA","l":"_395z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/decorate/index.less
// module id = 253
// module chunks = 0